import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { CreateChancel } from 'components';
import { FindLoad, FindSuccessItem, FindErrorItem, Images, useModal } from 'utils';
import { httpRequestsOnSuccessActions, systemActions } from 'store';

const ACTION_TYPE = 'CONNECT_GOOGLE_MEET';
export const ConnectGoogleMeet = () => {
    const { close } = useModal();
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);
    const backError = FindErrorItem(ACTION_TYPE);

    useEffect(() => {
        if (success) {
            close();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
        }
    }, [success, backError]);

    const handleCreate = () => {
        dispatch(systemActions.connectGoogleMeet());
    };

    return (
        <div style={{ width: 400 }}>
            <div className="office-ally-header" style={{ marginBottom: 12 }}>
                <div className="office-ally-header-icons">
                    <div>
                        <img src={Images.logoSmall} alt="" />
                    </div>
                    <img src={Images.compareArrows} alt="arrow" />
                    <div>
                        <img src={Images.googleMeet} alt="google meet" />
                    </div>
                </div>
                <p>Connect to Google Meet</p>
            </div>

            <p className="modal-header-sub">
                You will be redirected to Google to authorize your account.
                After granting permission, you'll be automatically redirected back to TherapyLake.
            </p>

            <div style={{ marginTop: 12 }}>
                <CreateChancel
                    onCreate={handleCreate}
                    loader={!!loader.length}
                    create={'Connect'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth={'100%'}
                />
            </div>
        </div>
    );
};
